var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "margin-top": "40px",
      "margin-left": "40px",
      "font-weight": "600"
    }
  }, [_vm._v("工资明细表")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('el-col', {
    staticStyle: {
      "background-color": "#f7f8fa",
      "height": "750px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('Structure', {
    ref: "Structure",
    attrs: {
      "condition": _vm.condition
    },
    on: {
      "parentFind": _vm.Find
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "tabs",
    attrs: {
      "span": 20
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "项目工资明细表",
      "name": "XmGzmx"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "2px"
    }
  }, [_c('div', [_c('el-row', [_c('div', {
    staticStyle: {
      "height": "660px",
      "padding-bottom": "100px",
      "background-color": "#FFFFFF"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding-left": "46px",
      "padding-top": "20px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('span', [_vm._v("时间")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "month",
      "placeholder": "请选择",
      "value-format": "yyyy-MM"
    },
    model: {
      value: (_vm.condition.years_date),
      callback: function($$v) {
        _vm.$set(_vm.condition, "years_date", $$v)
      },
      expression: "condition.years_date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Findxj
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t查询")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": function($event) {
        return _vm.openfileUrl()
      }
    }
  }, [_vm._v("导入")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导入",
      "visible": _vm.dialogVisibledr,
      "width": "30%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibledr = $event
      },
      "close": _vm.closeDialog
    }
  }, [_c('el-upload', {
    ref: "adModel",
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$globals.http + '/file/upload',
      "multiple": "",
      "file-list": _vm.fileList,
      "on-success": _vm.handleAvatarSuccess,
      "on-remove": _vm.handleRemove
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t选择文件")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [(_vm.fileDatatitle) ? _c('div', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("导入失败人员姓名：\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-start",
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.fileData), function(item, index) {
    return _c('div', {
      staticStyle: {
        "flex": "1",
        "width": "calc((100% - 20px) / 5)",
        "min-width": "calc((100% - 20px) / 5)",
        "max-width": "calc((100% - 20px) / 5)"
      }
    }, [_c('div', [_vm._v(_vm._s(item))])])
  }), 0)]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "background-color": "#006E4B",
      "border": "1px solid #006E4B",
      "margin": "30px 0 0 40%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.savefileUrl()
      }
    }
  }, [_vm._v("确 定")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('download-excel', {
    staticClass: "export-excel-wrapper",
    staticStyle: {
      "top": "100px",
      "width": "5%"
    },
    attrs: {
      "fields": _vm.download_excel,
      "name": _vm.condition.project_name,
      "fetch": _vm.ExportForm
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t导出")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticStyle: {
      "width": "110px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.heavyloadkq
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t更新考勤表")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticStyle: {
      "width": "110px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B",
      "margin-left": "25px"
    },
    on: {
      "click": _vm.heavyload
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t更新工资表")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "0px 2%",
      "margin-top": "10px",
      "font-weight": "bold"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('span', [_vm._v("实际出勤人数：" + _vm._s(_vm.total || '0'))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('span', [_vm._v("项目名称：" + _vm._s(_vm.condition.project_name))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.condition.actual_estimate),
      callback: function($$v) {
        _vm.$set(_vm.condition, "actual_estimate", $$v)
      },
      expression: "condition.actual_estimate"
    }
  }, [_vm._v("预估\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.condition.actual_estimate),
      callback: function($$v) {
        _vm.$set(_vm.condition, "actual_estimate", $$v)
      },
      expression: "condition.actual_estimate"
    }
  }, [_vm._v("实开\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [(this.kqje == null) ? _c('div', [_c('span', [_vm._v("开票金额：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "50%",
      "margin-left": "2px"
    },
    attrs: {
      "size": "mini",
      "type": "number",
      "placeholder": " ",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.invoiced_amount),
      callback: function($$v) {
        _vm.$set(_vm.condition, "invoiced_amount", $$v)
      },
      expression: "condition.invoiced_amount"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [(this.kqje !== null) ? _c('div', [_c('span', [_vm._v("开票金额：" + _vm._s(_vm.kqje))])]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [(this.kqje == null) ? _c('button', {
    staticStyle: {
      "width": "75px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B",
      "height": "28px",
      "text-align": "center:padding:auto",
      "border-radius": "5px"
    },
    on: {
      "click": _vm.savexj
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t确定")]) : _vm._e()])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "0px 2%",
      "margin-top": "10px",
      "font-weight": "bold"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [(this.kqje1 == null) ? _c('div', [_c('span', [_vm._v("实际物料：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "50%",
      "margin-left": "2px"
    },
    attrs: {
      "size": "mini",
      "placeholder": " ",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.actual_material),
      callback: function($$v) {
        _vm.$set(_vm.condition, "actual_material", $$v)
      },
      expression: "condition.actual_material"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [(this.kqje1 !== null) ? _c('div', [_c('span', [_vm._v("实际物料：" + _vm._s(_vm.kqje1))])]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [(this.kqje2 == null) ? _c('div', [_c('span', [_vm._v("临采物料：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "50%",
      "margin-left": "2px"
    },
    attrs: {
      "size": "mini",
      "placeholder": " ",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.temporary_materials),
      callback: function($$v) {
        _vm.$set(_vm.condition, "temporary_materials", $$v)
      },
      expression: "condition.temporary_materials"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [(this.kqje2 !== null) ? _c('div', [_c('span', [_vm._v("临采物料：" + _vm._s(_vm.kqje2))])]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [(this.kqje3 == null) ? _c('div', [_c('span', [_vm._v("工资绩效考核定额：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "50%",
      "margin-left": "2px"
    },
    attrs: {
      "size": "mini",
      "placeholder": " ",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.salary_performance),
      callback: function($$v) {
        _vm.$set(_vm.condition, "salary_performance", $$v)
      },
      expression: "condition.salary_performance"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [(this.kqje3 !== null) ? _c('div', [_c('span', [_vm._v("工资绩效考核定额：" + _vm._s(_vm.kqje3))])]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [(this.kqje4 == null) ? _c('div', [_c('span', [_vm._v("预算定额人数：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "50%",
      "margin-left": "2px"
    },
    attrs: {
      "size": "mini",
      "placeholder": " ",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.budget_quota_number),
      callback: function($$v) {
        _vm.$set(_vm.condition, "budget_quota_number", $$v)
      },
      expression: "condition.budget_quota_number"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [(this.kqje4 !== null) ? _c('div', [_c('span', [_vm._v("预算定额人数：" + _vm._s(_vm.kqje4))])]) : _vm._e()])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "0px 2%"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('el-table', {
    directives: [{
      name: "tableFit",
      rawName: "v-tableFit"
    }],
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#d3eae2',
        color: '#000000'
      },
      "border": true,
      "row-class-name": _vm.tableRowClassName,
      "data": _vm.tableData,
      "show-summary": "",
      "summary-method": _vm.getSummaries,
      "height": "590",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "50",
      "fixed": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "post_name",
      "align": "center",
      "label": "岗位",
      "width": "70",
      "fixed": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff_name",
      "align": "center",
      "label": "姓名",
      "width": "70",
      "fixed": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_wages",
      "align": "center",
      "label": "工资总额",
      "width": "60",
      "fixed": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "base_pay",
      "align": "center",
      "label": "基本工资",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "post_salary",
      "align": "center",
      "label": "岗位工资",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "daily_wage",
      "align": "center",
      "label": "日工资",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "days_attendance",
      "align": "center",
      "label": "应出勤天数",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "事假/缺勤"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "absence_days",
      "align": "center",
      "label": "天数",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deduction_absence",
      "align": "center",
      "label": "扣款",
      "width": "60"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "actual_attendance_days",
      "align": "center",
      "label": "实出勤天数",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "wages",
      "align": "center",
      "label": "工资额",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "增补项"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "full_work_attendance",
      "align": "center",
      "label": "满勤",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "70px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.full_work_attendance),
            callback: function($$v) {
              _vm.$set(scope.row, "full_work_attendance", $$v)
            },
            expression: "scope.row.full_work_attendance"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.full_work_attendance))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "meal_supplement",
      "align": "center",
      "label": "餐补",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "70px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.meal_supplement),
            callback: function($$v) {
              _vm.$set(scope.row, "meal_supplement", $$v)
            },
            expression: "scope.row.meal_supplement"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.meal_supplement))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "overtime",
      "align": "center",
      "label": "加班时间",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "overtime_amount",
      "align": "center",
      "label": "加班金额",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "70px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.overtime_amount),
            callback: function($$v) {
              _vm.$set(scope.row, "overtime_amount", $$v)
            },
            expression: "scope.row.overtime_amount"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.overtime_amount))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "substitute",
      "align": "center",
      "label": "替班",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "70px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.substitute),
            callback: function($$v) {
              _vm.$set(scope.row, "substitute", $$v)
            },
            expression: "scope.row.substitute"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.substitute))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "telephone_charges",
      "align": "center",
      "label": "话费",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "70px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.telephone_charges),
            callback: function($$v) {
              _vm.$set(scope.row, "telephone_charges", $$v)
            },
            expression: "scope.row.telephone_charges"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.telephone_charges))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "substitute_salary",
      "align": "center",
      "label": "代岗工资",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "70px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.substitute_salary),
            callback: function($$v) {
              _vm.$set(scope.row, "substitute_salary", $$v)
            },
            expression: "scope.row.substitute_salary"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.substitute_salary))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "make_up_for_the_early_stage",
      "align": "center",
      "label": "弥补前期",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "70px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.make_up_for_the_early_stage),
            callback: function($$v) {
              _vm.$set(scope.row, "make_up_for_the_early_stage", $$v)
            },
            expression: "scope.row.make_up_for_the_early_stage"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.make_up_for_the_early_stage))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reward",
      "align": "center",
      "label": "奖励",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "70px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.reward),
            callback: function($$v) {
              _vm.$set(scope.row, "reward", $$v)
            },
            expression: "scope.row.reward"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.reward))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "return_of_work_clothes_deposit",
      "align": "center",
      "label": "归还工服押金",
      "width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "70px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.return_of_work_clothes_deposit),
            callback: function($$v) {
              _vm.$set(scope.row, "return_of_work_clothes_deposit", $$v)
            },
            expression: "scope.row.return_of_work_clothes_deposit"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.return_of_work_clothes_deposit))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "other_plus",
      "align": "center",
      "label": "其他+",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "70px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.other_plus),
            callback: function($$v) {
              _vm.$set(scope.row, "other_plus", $$v)
            },
            expression: "scope.row.other_plus"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.other_plus))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "扣款项"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "late_deduction",
      "align": "center",
      "label": "迟到扣款",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "70px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.late_deduction),
            callback: function($$v) {
              _vm.$set(scope.row, "late_deduction", $$v)
            },
            expression: "scope.row.late_deduction"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.late_deduction))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "penalty_deduction",
      "align": "center",
      "label": "处罚扣款",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "70px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.penalty_deduction),
            callback: function($$v) {
              _vm.$set(scope.row, "penalty_deduction", $$v)
            },
            expression: "scope.row.penalty_deduction"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.penalty_deduction))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pay_the_work_clothes_deposit",
      "align": "center",
      "label": "发放工服押金",
      "width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "70px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.pay_the_work_clothes_deposit),
            callback: function($$v) {
              _vm.$set(scope.row, "pay_the_work_clothes_deposit", $$v)
            },
            expression: "scope.row.pay_the_work_clothes_deposit"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.pay_the_work_clothes_deposit))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "other_reduce",
      "align": "center",
      "label": "其他-",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "70px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.other_reduce),
            callback: function($$v) {
              _vm.$set(scope.row, "other_reduce", $$v)
            },
            expression: "scope.row.other_reduce"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.other_reduce))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "wages_payable",
      "align": "center",
      "label": "应发工资",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "代扣代缴"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "social_security_deduction",
      "align": "center",
      "label": "社保扣款",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accident_insurance",
      "align": "center",
      "label": "意外保险",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accumulation_fund",
      "align": "center",
      "label": "公积金",
      "width": "60"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "before_tax_paid_salary",
      "align": "center",
      "label": "实发工资(税前)",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "individual_income_tax",
      "align": "center",
      "label": "个人所得税",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "after_tax_paid_salary",
      "align": "center",
      "label": "实发工资(税后)",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "receiving_method_name",
      "align": "center",
      "label": "领取方式",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-right": "10px"
          },
          attrs: {
            "clearable": "",
            "size": "mini"
          },
          model: {
            value: (scope.row.receiving_method),
            callback: function($$v) {
              _vm.$set(scope.row, "receiving_method", $$v)
            },
            expression: "scope.row.receiving_method"
          }
        }, _vm._l((_vm.lqList), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "value": item.value,
              "label": item.label
            }
          })
        }), 1), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.receiving_method_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bank_card_number",
      "align": "center",
      "label": "银行卡号",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "150px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.bank_card_number),
            callback: function($$v) {
              _vm.$set(scope.row, "bank_card_number", $$v)
            },
            expression: "scope.row.bank_card_number"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.bank_card_number))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cardholder_name",
      "align": "center",
      "label": "持卡人",
      "width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "150px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.cardholder_name),
            callback: function($$v) {
              _vm.$set(scope.row, "cardholder_name", $$v)
            },
            expression: "scope.row.cardholder_name"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.cardholder_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "entry_name",
      "align": "center",
      "label": "项目名称",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id_card",
      "align": "center",
      "label": "身份证号",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "150px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.id_card),
            callback: function($$v) {
              _vm.$set(scope.row, "id_card", $$v)
            },
            expression: "scope.row.id_card"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.id_card))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "telephone_number",
      "align": "center",
      "label": "电话号",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "150px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.telephone_number),
            callback: function($$v) {
              _vm.$set(scope.row, "telephone_number", $$v)
            },
            expression: "scope.row.telephone_number"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.telephone_number))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "gender",
      "align": "center",
      "label": "性别",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "150",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('button', {
          staticStyle: {
            "width": "50px",
            "background-color": "#006E4B",
            "color": "#FFFFFF",
            "border": "1px solid #006E4B",
            "border-radius": "5px"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('button', {
          staticStyle: {
            "width": "50px",
            "background-color": "#006E4B",
            "color": "#FFFFFF",
            "border": "1px solid #006E4B",
            "border-radius": "5px"
          },
          on: {
            "click": function($event) {
              return _vm.save(scope.$index, scope.row)
            }
          }
        }, [_vm._v("保存")])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), (_vm.dialogVisible) ? _c('div', [_c('edit', {
    ref: "edit"
  })], 1) : _vm._e()])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "支援工资明细表",
      "name": "ZyGzmx"
    }
  }, [_c('ZyGzmx', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.is_edit),
      expression: "!is_edit"
    }],
    ref: "ZyGzmx",
    attrs: {
      "from": _vm.from,
      "condition": _vm.condition
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "审批人",
      "visible": _vm.sprdialogVisible,
      "width": "40%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.sprdialogVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": _vm.labelPosition,
      "label-width": "80px",
      "model": _vm.formLabelAlign
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审批名称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    model: {
      value: (_vm.reviewData.examine_name),
      callback: function($$v) {
        _vm.$set(_vm.reviewData, "examine_name", $$v)
      },
      expression: "reviewData.examine_name"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.reviewData.examineDetailsList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "node",
      "label": "节点",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "role_name",
      "label": "岗位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff_name",
      "label": "姓名",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.staff_ids == '' || scope.row.staff_ids == null) ? _c('el-select', {
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "multiple": "",
            "collapse-tags": "",
            "placeholder": "请选择"
          },
          model: {
            value: (scope.row.ids),
            callback: function($$v) {
              _vm.$set(scope.row, "ids", $$v)
            },
            expression: "scope.row.ids"
          }
        }, _vm._l((_vm.options), function(item) {
          return _c('el-option', {
            key: item.id,
            attrs: {
              "label": item.staff_name,
              "value": item.staff_id
            }
          })
        }), 1) : _vm._e(), _vm._v(" "), (scope.row.staff_ids != '' || scope.row.staff_ids != null) ? _c('span', [_vm._v(_vm._s(scope.row.staff_name))]) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#006E4B",
      "border": "1px solid #006E4B"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sprSave()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15e18150","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gzhsgl/GzMx/GzMx.vue
// module id = null
// module chunks = 